import { render, staticRenderFns } from "./SaveProgramDialog.vue?vue&type=template&id=35bf0fe8&scoped=true"
import script from "./SaveProgramDialog.vue?vue&type=script&lang=js"
export * from "./SaveProgramDialog.vue?vue&type=script&lang=js"
import style0 from "./SaveProgramDialog.vue?vue&type=style&index=0&id=35bf0fe8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bf0fe8",
  null
  
)

export default component.exports